 <template>
    <div>
		<div class="inbanner bg-cover">
        <el-image src="images/lb/lxwm.jpg"></el-image>

      <!-- <div class="inwrap l-m-c">
        <h2 class="fnt_40 wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">联系我们</h2>
        <h3 class="fnt_18 wow fadeInUp animated animated" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">Product center</h3>
      </div> -->
    </div>
    <!-- contact -->
	<div class="contact">
		<div class="container">   
			<div class="map ">
				<iframe src="https://map.baidu.com/poi/%E5%B1%B1%E8%A5%BF%E5%A4%AA%E5%8E%9F%E8%8D%AF%E4%B8%9A%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@12524320.678638022,4526206.637942934,16.75z?uid=4ea3f2f145b410abaecb6651&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl" allowfullscreen></iframe>
			</div> 
			<!-- //map -->  
			<div class="map-pos">
				<div class="col-md-4 address-row animate__animated animate__fadeInUp">
					<div class="col-xs-2 address-left  ">
						<span class="glyphicon glyphicon-home" aria-hidden="true"></span>
					</div>
					<div class="col-xs-10 address-right">
						<h5>地址</h5>
						<p>山西省太原市晋源区化工路21号</p>
					</div>
					<div class="clearfix"> </div>
				</div>
				<div class="col-md-4 address-row w3-agileits animate__animated animate__fadeInUp">
					<div class="col-xs-2 address-left">
						<span class="glyphicon glyphicon-envelope" aria-hidden="true"></span>
					</div>
					<div class="col-xs-10 address-right">
						<h5>发邮件</h5>
						<p>shanxliye@sxlyzy.club</p>
					</div>
					<div class="clearfix"> </div>
				</div>
				<div class="col-md-4 address-row animate__animated animate__fadeInUp">
					<div class="col-xs-2 address-left">
						<span class="glyphicon glyphicon-phone" aria-hidden="true"></span>
					</div>
					<div class="col-xs-10 address-right">
						<h5>电话</h5>
						<p>0351-6070200</p>
					</div>
					<div class="clearfix"> </div>
                  
				</div>  
				<div class="clearfix"> </div>
			</div>  
			<lianxidianhua-area></lianxidianhua-area>
			<div class="clearfix"> </div>
				<div class="col-sm-6 contact-left">
					<input type="text" name="Name" v-model="form.name" placeholder="名字" required="">
					<input type="email" name="Email" v-model="form.email" placeholder="邮箱" required="">
					<input type="text" name="Mobile Number" v-model="form.phone" placeholder="电话" required="">
				</div>
				<div class="col-sm-6 contact-right"> 
					<textarea name="Message" v-model="form.content" placeholder="内容" required=""></textarea>
					<input type="submit" 	 v-on:click="add"  value="提交" >
				</div>
				<div class="clearfix"></div>
		</div>
	</div>  
	<!-- //contact -->  
    </div>
 </template>
 <script lang="js">

import * as  http from '@/request/http';

import lianxidianhuaArea from './lianxidianhuaArea.vue'

export default {
	components: {
    // IndexProducts,
    lianxidianhuaArea
   },
  data(){
	return {
		PortalContactUs:{},
		form: {}
	}
  },
  methods: {
	add() {
      http.contactUs.contactUsadd(this.form).then(res=>{
          alert("提交成功！")
      })
    }
  }
}
</script>